export const serviceMapper = {
    N: "Postpaid Service",
    Y: "Prepaid Service"
}

export const formatDate = (date) => {
    try{
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = String(d.getFullYear()).slice(-2); // Get last two digits
  
    return `${day}/${month}/${year}`;}
    catch{
        return date
    }
  };
  